module.exports = __webpack_public_path__ + "static/media/petition.1598ca67.svg";